import {PurchaseOrderItem} from './purchase-order-item';

export class PurchaseOrderItemCollection {
    private totalItems: number = 0;
    private purchaseOrderItems: PurchaseOrderItem[] = [];

    setTotalItems(totalItems: number) {
        this.totalItems = totalItems;
    }

    setPurchaseOrderItems(purchaseOrderItems: PurchaseOrderItem[]) {
        this.purchaseOrderItems = purchaseOrderItems;
    }

    getTotalItems(): number {
        return this.totalItems;
    }

    getPurchaseOrderItems(): PurchaseOrderItem[] {
        return this.purchaseOrderItems;
    }
}
